/**
 * Massy custom pricing replaces `.f-price--with-payment-options` elements with its own
 * <massy-custom-pricing> element, which only renders the raw (discounted) price and drops
 * the theme's Pix discount / installment info. This watches for those replacements and
 * re-applies the Pix discount + installment text on top of whatever price Massy is showing.
 */
(function () {
  'use strict';

  function getConfig() {
    var settings = (window.FoxTheme && window.FoxTheme.paymentOptions) || {};
    return {
      pixDiscountPercent: parseFloat(settings.pixDiscountPercent) || 10,
      installmentCount: parseInt(settings.installmentCount, 10) || 12,
      minInstallmentValue: parseFloat(settings.minInstallmentValue) || 50,
    };
  }

  function parseBRL(text) {
    if (!text) return null;
    var digits = text.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    var value = parseFloat(digits);
    return isNaN(value) ? null : value;
  }

  function formatBRL(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function enhance(el) {
    var priceEl =
      el.querySelector('.massy-custom-pricing-price-discount') ||
      el.querySelector('.massy-custom-pricing-price');
    if (!priceEl) return;

    var rawText = priceEl.textContent.trim();

    // Skip if this is just an echo of the text we ourselves wrote last time.
    if (el.dataset.massyLastOutput === rawText) return;

    var price = parseBRL(rawText);
    if (price === null) return;

    var config = getConfig();
    var pixPrice = (price * (100 - config.pixDiscountPercent)) / 100;
    var installmentValue = price / config.installmentCount;

    var pixText = formatBRL(pixPrice);
    priceEl.textContent = pixText;
    el.dataset.massyLastOutput = pixText;

    var pixInfo = el.querySelector(':scope > .f-price__pix-info');
    if (!pixInfo) {
      pixInfo = document.createElement('div');
      pixInfo.className = 'f-price__pix-info text-subtext';
      el.appendChild(pixInfo);
    }
    pixInfo.textContent = 'à vista no pix com ' + config.pixDiscountPercent + '% de desconto';

    var installmentsEl = el.querySelector(':scope > .f-price__installments');
    if (installmentValue >= config.minInstallmentValue) {
      if (!installmentsEl) {
        installmentsEl = document.createElement('div');
        installmentsEl.className = 'f-price__installments text-subtext';
        el.appendChild(installmentsEl);
      }
      installmentsEl.textContent =
        'ou ' +
        formatBRL(price) +
        ' em ' +
        config.installmentCount +
        'x de ' +
        formatBRL(installmentValue) +
        ' sem juros no cartão';
    } else if (installmentsEl) {
      installmentsEl.remove();
    }
  }

  function scan(root) {
    var scope = root.querySelectorAll ? root : document;
    scope.querySelectorAll('massy-custom-pricing.f-price--with-payment-options').forEach(enhance);
  }

  var debounceTimers = new WeakMap();

  function scheduleEnhance(el) {
    if (debounceTimers.has(el)) {
      clearTimeout(debounceTimers.get(el));
    }
    debounceTimers.set(
      el,
      setTimeout(function () {
        debounceTimers.delete(el);
        enhance(el);
      }, 50)
    );
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('massy-custom-pricing.f-price--with-payment-options')) {
          scheduleEnhance(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('massy-custom-pricing.f-price--with-payment-options').forEach(scheduleEnhance);
        }
      });

      var target = mutation.target;
      var owner = target && target.closest && target.closest('massy-custom-pricing.f-price--with-payment-options');
      if (owner) {
        scheduleEnhance(owner);
      }
    });
  });

  function start() {
    scan(document);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
